/* eslint-disable react/prop-types */
const BioImage = ({ src, alt = '' }) => (
  <img src={src} alt={alt} className="rounded mb-4" style={{ width: '75vw', maxWidth: '500px' }} />
);

export default BioImage;
